import { fg } from '@atlassian/jira-feature-gating';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';

export const isSecurityPageEnabled = () =>
	!isDevopsFeatureDisabledInFedRamp() && fg('isotopes-security-page-in-jira-enabled-v2');
